import SceneUtils from "../utils/sceneUtils";
import {isMobile} from "../utils/utils";

export default class BaseScene extends Phaser.Scene {

    constructor(config) {
        super(config);
    }

    create(){
        this.cameras.main.fadeIn(1000, 0, 0, 0);
        this.input.on("pointerup", () => {
            try{
                if(isMobile()) {
                    SceneUtils.startFullscreen(this);
                }
            } catch(e){
                console.log("Could not enter fullscreen");
            }
        })
    }
}